/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { OpportunityBreakdown } from "./OpportunityBreakdown";
import {
  OpportunityBreakdownFromJSON,
  OpportunityBreakdownFromJSONTyped,
  OpportunityBreakdownToJSON,
  OpportunityBreakdownToJSONTyped,
} from "./OpportunityBreakdown";
import type { OpportunitySummary } from "./OpportunitySummary";
import {
  OpportunitySummaryFromJSON,
  OpportunitySummaryFromJSONTyped,
  OpportunitySummaryToJSON,
  OpportunitySummaryToJSONTyped,
} from "./OpportunitySummary";
import type { OpportunityFreightProfile } from "./OpportunityFreightProfile";
import {
  OpportunityFreightProfileFromJSON,
  OpportunityFreightProfileFromJSONTyped,
  OpportunityFreightProfileToJSON,
  OpportunityFreightProfileToJSONTyped,
} from "./OpportunityFreightProfile";
import type { OpportunityLane } from "./OpportunityLane";
import {
  OpportunityLaneFromJSON,
  OpportunityLaneFromJSONTyped,
  OpportunityLaneToJSON,
  OpportunityLaneToJSONTyped,
} from "./OpportunityLane";
import type { OpportunityDataWindow } from "./OpportunityDataWindow";
import {
  OpportunityDataWindowFromJSON,
  OpportunityDataWindowFromJSONTyped,
  OpportunityDataWindowToJSON,
  OpportunityDataWindowToJSONTyped,
} from "./OpportunityDataWindow";
import type { OpportunityCoverage } from "./OpportunityCoverage";
import {
  OpportunityCoverageFromJSON,
  OpportunityCoverageFromJSONTyped,
  OpportunityCoverageToJSON,
  OpportunityCoverageToJSONTyped,
} from "./OpportunityCoverage";

/**
 *
 * @export
 * @interface OpportunityDetail
 */
export interface OpportunityDetail {
  /**
   *
   * @type {OpportunitySummary}
   * @memberof OpportunityDetail
   */
  summary: OpportunitySummary;
  /**
   *
   * @type {OpportunityDataWindow}
   * @memberof OpportunityDetail
   */
  dataWindow: OpportunityDataWindow;
  /**
   *
   * @type {Array<OpportunityBreakdown>}
   * @memberof OpportunityDetail
   */
  pickupLocations: Array<OpportunityBreakdown>;
  /**
   *
   * @type {Array<OpportunityLane>}
   * @memberof OpportunityDetail
   */
  lanes: Array<OpportunityLane>;
  /**
   *
   * @type {OpportunityFreightProfile}
   * @memberof OpportunityDetail
   */
  freightProfile: OpportunityFreightProfile;
  /**
   *
   * @type {OpportunityCoverage}
   * @memberof OpportunityDetail
   */
  coverage?: OpportunityCoverage;
}

/**
 * Check if a given object implements the OpportunityDetail interface.
 */
export function instanceOfOpportunityDetail(
  value: object,
): value is OpportunityDetail {
  if (!("summary" in value) || value["summary"] === undefined) return false;
  if (!("dataWindow" in value) || value["dataWindow"] === undefined)
    return false;
  if (!("pickupLocations" in value) || value["pickupLocations"] === undefined)
    return false;
  if (!("lanes" in value) || value["lanes"] === undefined) return false;
  if (!("freightProfile" in value) || value["freightProfile"] === undefined)
    return false;
  return true;
}

export function OpportunityDetailFromJSON(json: any): OpportunityDetail {
  return OpportunityDetailFromJSONTyped(json, false);
}

export function OpportunityDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OpportunityDetail {
  if (json == null) {
    return json;
  }
  return {
    summary: OpportunitySummaryFromJSON(json["summary"]),
    dataWindow: OpportunityDataWindowFromJSON(json["dataWindow"]),
    pickupLocations: (json["pickupLocations"] as Array<any>).map(
      OpportunityBreakdownFromJSON,
    ),
    lanes: (json["lanes"] as Array<any>).map(OpportunityLaneFromJSON),
    freightProfile: OpportunityFreightProfileFromJSON(json["freightProfile"]),
    coverage:
      json["coverage"] == null
        ? undefined
        : OpportunityCoverageFromJSON(json["coverage"]),
  };
}

export function OpportunityDetailToJSON(json: any): OpportunityDetail {
  return OpportunityDetailToJSONTyped(json, false);
}

export function OpportunityDetailToJSONTyped(
  value?: OpportunityDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    summary: OpportunitySummaryToJSON(value["summary"]),
    dataWindow: OpportunityDataWindowToJSON(value["dataWindow"]),
    pickupLocations: (value["pickupLocations"] as Array<any>).map(
      OpportunityBreakdownToJSON,
    ),
    lanes: (value["lanes"] as Array<any>).map(OpportunityLaneToJSON),
    freightProfile: OpportunityFreightProfileToJSON(value["freightProfile"]),
    coverage: OpportunityCoverageToJSON(value["coverage"]),
  };
}
